import { DEFAULT_CONFIG } from '../constants';
import type { PublicConfig } from '../types';
import { api } from './api';

let cached: PublicConfig | null = null;
export async function getPublicConfig(signal?: AbortSignal): Promise<PublicConfig> {
  if (cached) return cached;
  try {
    cached = { ...DEFAULT_CONFIG, ...(await api.get<PublicConfig>('/config/public', signal)) };
  } catch {
    cached = DEFAULT_CONFIG;
  }
  return cached;
}
